import { render } from "./CloseButton.vue?vue&type=template&id=b65fd066"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script